import { render, staticRenderFns } from "./SpecimenStatusChangedBody.vue?vue&type=template&id=76246062"
import script from "./SpecimenStatusChangedBody.vue?vue&type=script&lang=js"
export * from "./SpecimenStatusChangedBody.vue?vue&type=script&lang=js"
import style0 from "./SpecimenStatusChangedBody.vue?vue&type=style&index=0&id=76246062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports